import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { NotificationListComponent } from '../../pages/shared/notification-list/notification-list.component';
import { AuthService } from '../../service/auth/auth.service';
import { CommonService } from '../../service/helper/common.service';
import { HeaderService } from '../../service/helper/header.service';
import { ScreenService } from '../../service/helper/screen.service';
import { CommonModalComponent } from '../common-modal/common-modal.component';
import { TablerIcon } from '../tabler-icon/tabler-icon-list';
import { TablerIconComponent } from '../tabler-icon/tabler-icon.component';

type NotificationModel = any

@Component({
  selector: 'app-header',
  imports: [CommonModule, TablerIconComponent, NotificationListComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  _TablerIcon = TablerIcon

  @Input() unAuthen: boolean = false;

  isMobile$!: Observable<boolean>;
  isTablet$!: Observable<boolean>;
  isPc$!: Observable<boolean>;

  selectedNotiMobile: NotificationModel | null = null

  userDetail: any = null
  menuList: any[] = []

  isNotiMobileDetailOpen: boolean = false;
  private subscriptions: Subscription[] = [];

  title: string = 'จัดการสิทธิประโยชน์ (คะแนนสะสม)'
  subTitle: string = 'จัดการคูปองแลกรางวัล'

  chat_noti_count: number = 0

  constructor(
    private router: Router,
    private dialog: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private screenService: ScreenService,
    private headerService: HeaderService
  ) {
    // this.userDetail = this.authService.getUserCredential()
    this.authService.menuAndPermission$.subscribe(menu => {
      if (menu) {
        this.menuList = menu
        console.log('menuList', this.menuList)
      }
    })

    this.headerService


    this.isMobile$ = this.screenService.isMobile$();
    this.isTablet$ = this.screenService.isTablet$();
    this.isPc$ = this.screenService.isPc$();

    this.initClearStateResponsive()
  }

  ngOnInit() {
    this.headerService.title$.subscribe(res => this.title = res);
    this.headerService.subTitle$.subscribe(res => this.subTitle = res);
  }

  toggleNotiMobileDetailcanvas(noti?: NotificationModel): void {
    this.isNotiMobileDetailOpen = !this.isNotiMobileDetailOpen;

    if (noti) {
      this.selectedNotiMobile = noti
    } else {
      this.selectedNotiMobile = null
    }
  }

  initClearStateResponsive() {
    this.subscriptions.push(
      this.isMobile$.subscribe(isMobile => {
        this.isNotiMobileDetailOpen = false;
      }),
      this.isTablet$.subscribe(isTablet => {
        this.isNotiMobileDetailOpen = false;
      }),
      this.isPc$.subscribe(isPc => {
        this.isNotiMobileDetailOpen = false;
      })
    );
  }

  goLoginPage() {
    this.router.navigateByUrl('/auth/login')
  }


  goPointSummaryPage() {
    this.router.navigateByUrl('/')
  }

  goMemberPage() {
    this.router.navigateByUrl('/')
  }

  goUserRequestPage() {
    this.router.navigateByUrl('/')
  }

  goHomePage() {
    this.router.navigateByUrl('/')
  }

  goConsentPage() {
    this.router.navigateByUrl('/')
  }

  goAgriAreaPage() {
    this.router.navigateByUrl('/')
  }

  goCalendarPage() {
    this.router.navigateByUrl('/')
  }

  goShopPage() {
    this.router.navigateByUrl('/')
  }

  goServicePage() {
    this.router.navigateByUrl('/')
  }

  goChatPage() {
    this.router.navigateByUrl('/')
  }

  logout() {
    let dialog = this.dialog.open(CommonModalComponent, {
      centered: true,
    });

    let dialogInst = dialog.componentInstance as CommonModalComponent

    dialogInst.modalType = 'danger';
    dialogInst.htmlContent = 'คุณต้องการจะออกจากระบบ?';
    dialogInst.iconConfirmBtn = 'logout';
    dialogInst.textConfirmBtn = 'ออกจากระบบ';
    dialogInst.onConfirmPress.subscribe((value) => {
      this.authService.logout()
      this.router.navigateByUrl('/auth/login')
    })
  }


  checkPermission(menu_id: number, permission_type: number): boolean {
    return this.authService.checkPermission(menu_id, permission_type)
  }


}
